<template>
  <div class="scrollMarker" :style="inlineStyles" />
</template>

<script>
import { mapGetters } from "vuex";
import { vuexGetters } from "../store";
export default {
  name: "ScrollMarker",
  props: {
    top: {
      type: Number,
      required: true
    }
  },
  computed: {
    ...mapGetters({ scrolled: vuexGetters.SCROLL_PERCENT }),
    inlineStyles() {
      return {
        top: this.top ? `${this.top}px` : "inherit",
        right: `calc(${100 - this.scrolled}% - 5px)`
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.scrollMarker {
  background-color: $eminence;
  position: fixed;
  top: 65px;
  right: calc(100% + 10px);
  left: -5px;
  height: 5px;
  border-radius: 5px;
}
</style>